import { Link } from 'react-router-dom';
import Pagination from '../../../shared/components/Pagination';
import ResumeItem from '../../../shared/components/ResumeItem';

const SearchResumes = ({ list, pages, setListData }) => {
    return (
        <div id="talent-news">
            <div className="top-table">
                <div className="count-results">
                    인재정보{' '}
                    <span>
                        총 <span className="high-light-number">{pages.totalRow}</span>건
                    </span>
                </div>
                <Link to="/pafaa010" className="more-results green">
                    인재정보 보기 &gt;
                </Link>
            </div>
            <ul className="table wrap-table table-three-column">
                {list.map((item, index) => (
                    <ResumeItem
                        item={item}
                        key={index}
                        setResumeList={setListData}
                        roleAction="C"
                        showStar={true}
                        detailUrl="list"
                    />
                ))}
            </ul>
            <Pagination pages={pages} params="pageResume" />
        </div>
    );
};

export default SearchResumes;
